import React from 'react';
import "./NavBar.css";
import cartpool from "../Icons/cartpool-logo.png"
import ShoppingCart from "../Icons/shopping-cart.svg";
import profile from "../Icons/profile.svg";
import { useNavigate } from 'react-router-dom';
const NavBar = (props) => {
    const navigate = useNavigate();

    const handleCartClick = () => {
        navigate('/cart'); // Navigate to /cart route
    };
    const handleCartClick2 = () => {
        navigate('/waitlist'); // Navigate to /cart route
    };

    const handleCartIconClick = () => {
        navigate('/'); // Navigate to landing page route
    };

    return(
        <div className="navbar">

            <div className='about-shop'>
                <button className='about-button' onClick={handleCartClick2}>About</button>
                <button className='shop-button' onClick={handleCartIconClick}>Shop</button>

            </div>

            <button className='carticon-button' onClick={handleCartIconClick}>
                <img src={cartpool} alt="carticon" className='carticon'/>
            </button>

            
            <div className='cartprofile'>
                <button className='profile-button'>
                <img src={profile} alt="Profile Icon"/>
                </button>
                <button className="cart-button" onClick={props.handleCartClick ? props.handleCartClick : handleCartClick}>
                    {/* if u pass in handlecartclick as prop  */}
                    <img src={ShoppingCart} alt="Shopping cart Icon"/>
                    
                </button>
            </div>

        </div>
    );
};

export default NavBar;

